import React from "react";

import { CustomDiv } from "./styles";

const CenterWrapper: React.FC = ({ children }) => {
  return <CustomDiv>{children}</CustomDiv>;
};

export default CenterWrapper;
